// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","578":"Pizza"}[chunkId] + "." + {"72":"fae4a658","187":"9929dfe2","578":"837edd2f"}[chunkId] + ".chunk.js";
};